// extracted by mini-css-extract-plugin
export default {"subMenu":"styles_subMenu__LoVqo","subMenuButton":"styles_subMenuButton__Irs+T","icon":"styles_icon__w0Ozp","stacked":"styles_stacked__tD9pu"};